import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-deal-team-navigation',
  templateUrl: './deal-team-navigation.component.html',
  styleUrls: ['./deal-team-navigation.component.scss']
})
export class DealTeamNavigationComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
